import { NgxSpinnerService } from 'ngx-spinner';
import { CadastroVendedorService } from './../../../services/cadastro-vendedor.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cadastro-vendedor',
  templateUrl: './cadastro-vendedor.component.html',
  styleUrls: ['./cadastro-vendedor.component.scss']
})
export class CadastroVendedorComponent implements OnInit {

  vendedores = [];

  cadastroVendedor: FormGroup;
  msg: { type: string, message: string };

  constructor(private fb: FormBuilder,
    private cadastroVendedorService: CadastroVendedorService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {



    this.cadastroVendedor = this.fb.group({
      email: ['', Validators.required],
      nome: ['', Validators.required],
      senha: ['', Validators.required],
      sigla_marca: ['', Validators.required]
    });


    /*
    this.vendedores.forEach(async (item) => {
      await this.cadastroVendedorService.cadastrarVendedor(item);
    });
    */


  }



  async cadastrarVendedor() {
    if (this.cadastroVendedor.valid) {
      this.spinner.show();
      const result = await this.cadastroVendedorService.cadastrarVendedor(this.cadastroVendedor.value);
      this.spinner.hide();
      if (result.success) {
        this.msg = {
          type: "alert-success",
          message: result.message
        }
        this.cadastroVendedor.reset();
      } else {
        this.msg = {
          type: "alert-danger",
          message: result.message
        }
      }
    }
  }

}
